import React from 'react';
import HelloAppH5Page from '../hello-app-h5/common/HelloAppH5Page';
import { HelloSellerAppH5Config } from './HelloSellerAppH5Config';

const HelloSellerAppH5Page: React.FC = () => (
  <HelloAppH5Page
    role="seller"
    documentTitle={HelloSellerAppH5Config.documentTitle}
    shareButtonLabel={HelloSellerAppH5Config.shareButtonLabel}
    downloadButtonLabel={HelloSellerAppH5Config.downloadButtonLabel}
    iosAppStoreUrl={HelloSellerAppH5Config.iosAppStoreUrl}
    androidApkUrl={HelloSellerAppH5Config.androidApkUrl}
    shareOpenBaseOnly
    backgroundImageUrl={`${process.env.PUBLIC_URL}/h5bg/seller.png`}
    placeholderBackgroundColor="#121a21"
    buttonBackgroundColor="#FFDA86"
    buttonTextColor="#1a1a1a"
  />
);

export default HelloSellerAppH5Page;
